import { alertError, alertSuccess } from './alert';
import api, { isResponseOk } from '../../utils/api';
import { setBulkVariantEdit, setInventory, setSelectedVariants } from './supplierInventory';
import { INVENTORY_MANUAL_UPDATE_ACTIONS } from '../constants/updateInventoryManualActions';

export const postVariantBuffers = (bufferValue, variantIds) => async (dispatch, getState) => {
  dispatch(setBulkVariantEdit({ isLoading: true }));

  const state = getState();
  const { supplierId } = state.role;
  const { data, count } = state.supplierInventory;
  const params = {
    variant_ids: variantIds,
    buffer: bufferValue,
  };

  try {
    const url = `/suppliers/${supplierId}/variants/inventory-buffers`;
    const response = await api.post(url, params);
    if (!isResponseOk(response)) {
      dispatch(alertError(new Error(response.data.message)));
      return;
    }
    dispatch(
      alertSuccess(
        'The buffer amounts have been updated successfully and will be synced to your sales channel(s) within the next hour',
      ),
    );
    dispatch(setBulkVariantEdit({ isLoading: false, isSuccess: true }));
    dispatch(
      setInventory({
        data: constructNewDataForBuffers({ data, editedIds: variantIds, bufferValue }),
        count,
      }),
    );
  } catch (error) {
    dispatch(alertError(error));
    dispatch(setBulkVariantEdit({ isLoading: false, isSuccess: false }));
  } finally {
    dispatch(setSelectedVariants());
  }
};

export const postVariantQuantities =
  ({ quantity, warehouseId, variantIds }, fetchInventory) =>
  async (dispatch, getState) => {
    dispatch(setBulkVariantEdit({ isLoading: true }));

    const state = getState();
    const { supplierId } = state.role;

    try {
      const url = `/suppliers/${supplierId}/variants/inventory-manual-updates`;
      const response = await api.post(url, {
        quantity,
        warehouseId,
        variantIds,
        action: INVENTORY_MANUAL_UPDATE_ACTIONS.updateQuantities,
      });
      if (!isResponseOk(response)) {
        dispatch(alertError(new Error(response.data.message)));
        return;
      }

      await fetchInventory();

      dispatch(alertSuccess('Inventory amounts updated.'));
      dispatch(setBulkVariantEdit({ isLoading: false, isSuccess: true }));
    } catch (error) {
      console.error('error updating inventory amounts', error);

      dispatch(alertError('Unable to update the inventory amounts. Please try again.'));
      dispatch(setBulkVariantEdit({ isLoading: false, isSuccess: false }));
    } finally {
      dispatch(setSelectedVariants());
    }
  };

const constructNewDataForBuffers = ({ data, editedIds, bufferValue }) => {
  return data.map((inventoryRow) => {
    return {
      ...inventoryRow,
      variant_inventory_buffer: editedIds.includes(inventoryRow.object_id)
        ? bufferValue
        : inventoryRow.variant_inventory_buffer,
    };
  });
};
